import React from 'react';
import { useAuthToken, useOnMount, useUpdateSonarObjectReference } from '@hooks';

type AdminSonarWindow = Window &
	typeof globalThis & {
		sonar: {
			sonarObjectReference: ReturnType<typeof useUpdateSonarObjectReference>;
		};
	};

export const AdminReferenceDebugger: React.FC = () => {
	const { isAdmin } = useAuthToken();
	const sonarObjectReference = useUpdateSonarObjectReference();

	useOnMount(() => {
		if (isAdmin) {
			(window as AdminSonarWindow).sonar.sonarObjectReference = sonarObjectReference;
		}
	});

	return null;
};
